/**
 * Mapping for translation keys, so we don't have to use long text in source code. Please keep in mind, that the
 * german default translations are the keys, so don't change them, if you wan't to change the text.
 * Instead change the de_DE translations!
 */
export const KEYS = {
  GRID: {
    DEVICES: "Geräte",
    DEVICE_NAME: "Gerätename",
    DEVICE_ID: "Geräte-ID",
    PATIENT: "Patient",
    PATIENTS: "Patienten",
    OPTIONS: "Optionen",
    DELETE_DEVICE: "Gerät löschen",
    ENTRIES: "Einträge",
    TYP: 'Typ',
    BROWSER: 'Browser',
    DEVICE: 'Gerät',
    QUESTION_DELETE_DEVICE: "Möchten Sie das Gerät wirklich löschen?",
    SUCCESSFULLY_DELETED_DEVICE: "Das Gerät wurde erfolgreich gelöscht.",
    ERROR_DELETING_DEVICE: "Beim Löschen des Geräts ist ein Fehler aufgetreten.",
    ERROR_LOADING_DEVICE_LIST: "Beim Laden der Geräteliste ist ein Fehler aufgetreten.",
    SEARCH: 'Suche',
    TYPE_BROWSER: 'Browser',
    TYPE_DEVICE: 'Gerät',
    TYPE_ALL: 'Alle'
  },
  CRUD: {
    INIT_DEVICE: "Gerät initialisieren",
    INIT_DEVICE_HELP_TEXT: "Bitte scannen sie folgenden QR-Code mit der App, um ein neues Gerät hinzuzufügen.",
    INSTALL_APP_HELP_TEXT: "Die App können sie bequem auf einem Gerät installieren, indem sie den jeweils für die Platform passenden QR-Code damit scannen.",
    TITLE: 'Gerät hinzufügen',
    SUBTITLE: 'Verbinden Sie ein Tablet oder Smartphone in drei Schritten mit dieser myMedax Instanz.',
    STEP_INSTALL: 'myMedax App auf dem Gerät installieren',
    STEP_WIFI: 'Gerät mit dem WLAN verbinden',
    STEP_SCAN: 'Diesen QR-Code in der App scannen',
    SERVER: 'Inhalt des QR-Codes',
    INSTALL_APP: 'App installieren',
    INSTALL_APP_TEXT: 'Noch keine App auf dem Gerät? Scannen Sie den Code für die passende Plattform mit der Kamera.',
    IOS_STORE: 'iOS (App Store)',
    ANDROID_STORE: 'Android (Play Store)',
    ANDROID_DOWNLOAD: 'Android (Download)',
    OPEN_STORE: 'Im Store öffnen',
    DOWNLOAD: 'Herunterladen'
  }
};
